import React, { useEffect, useState } from "react";
import { clockFace, countdownClock, dayPhrase, nextStep, todayTitle } from "@/lib/nowPlan.js";

function pad(value) {
  return String(value).padStart(2, "0");
}

export function TodayNow({ now, onOpen }) {
  const [clock, setClock] = useState(() => now || new Date());
  useEffect(() => {
    const id = window.setInterval(() => setClock(new Date()), 1000);
    return () => window.clearInterval(id);
  }, []);
  const step = nextStep(clock, true);
  const left = step.until ? countdownClock(clock, step.until) : null;
  const dayWord = left && left.days > 1 ? "jours" : "jour";
  return (
    <section className="og-now" data-testid="today-now">
      <h2 className="og-now__title" data-testid="today-title">{todayTitle(clock)}</h2>
      <p className="og-now__clock" data-testid="today-clock">{dayPhrase(clock)} · {clockFace(clock)}</p>
      <div className="og-now__line">
        <p className="og-now__step" data-testid="next-step">Prochaine étape · {step.label}</p>
        <p className="og-now__count" data-testid="hunt-countdown">
          {left && step.prefix ? (
            <>
              <span className="og-count__lead">{step.prefix}</span>
              {" "}
              <span className="og-count__bit"><span className="og-count__n">{left.days}</span> <span className="og-count__u">{dayWord}</span></span>
              {" "}
              <span className="og-count__bit"><span className="og-count__n">{pad(left.hours)}</span> <span className="og-count__u">h</span></span>
              {" "}
              <span className="og-count__bit"><span className="og-count__n">{pad(left.minutes)}</span> <span className="og-count__u">min</span></span>
              {" "}
              <span className="og-count__bit"><span className="og-count__n">{pad(left.seconds)}</span> <span className="og-count__u">s</span></span>
            </>
          ) : (step.countdown || "Maintenant")}
        </p>
      </div>
      <div className="og-now__actions">
        <button type="button" className="og-btn og-btn--primary" data-testid="open-day" onClick={() => onOpen("day")}>Voir ma journée</button>
        <button type="button" className="og-btn og-btn--primary" data-testid="check-route" onClick={() => onOpen("route")}>Vérifier mon trajet</button>
        <button type="button" className="og-btn og-btn--primary" data-testid="open-group-map" onClick={() => onOpen("group-map")}>Carte du groupe</button>
        <button type="button" className="og-btn" data-testid="open-weather" onClick={() => onOpen("weather")}>Conditions de chasse</button>
      </div>
    </section>
  );
}
